export const LEADING_ICON_COLUMN_DEF = 'LEADING_ICON'
